module.exports = {
	"INLINE": "Testesssss",
	"nav_home": "Start",
	"nav_menu": "Speisekarte",
	"nav_about": "Restaurant",
	"nav_wines": "Wein",
	"nav_suggestions": "Vorschläge",
	"nav_events": "Veranstaltungen",
	"nav-feedback": "Deine Meinung",
	"follow_text": "Folge uns",
	"desktop_languages": "Sprachen",
	"intro_default_option": "Filtermenü nach:",
	"suggested_extras": "Empfohlene Beilagen",
	"suggested_wines": "Empfohlene Weine",
	"cta_title": "Sehen Sie unsere Auswahl an ",
	"cta_btn": "Sehen",
	"related_products": "Ähnliche Produkte",
	"error_home_link": "Zurück zum Start",
	"error_home_title1": "Hmm...",
	"error_home_title2": "Die gesuchte Seite wurde nicht gefunden.",
	"error_home_text": "Versuchen Sie, die Adresse neu zu schreiben, oder versuchen Sie es später erneut.",
	"detail_title": "im Detail",
	"list_event_title": "Veranstaltungen",
	"event_link": "Offizielle Seite",
	"other_events": "Andere Ereignisse",
	"filters": "Filter",
	"filter-group-region-type": "Weinsorte und Region",
	"region_default_option": "Wählen Sie eine Region",
	"filter-group-type": "Typ",
	"type_default_option": "Wählen Sie einen Typ",
	"filter-group-flavour": "Geschmack",
	"filter-group-characteristics": "Weineigenschaften",
	"sweetness_default_option": "Säure",
	"filter-group-body": "Körper",
	"body_default_option": "Wähle den Körper",
	"filter-group-ingredients": "Hauptzutaten",
	"filter-group-diets": "Unverträglichkeiten",
	"filter-results": "{results} Ergebnisse",
	"filter-clear-button": "Filter löschen",
	"filter-apply-button": "Bewerben",
	"related_dishes": "Empfohlene Gerichte",
	"empty-title": "Keine Ergebnisse",
	"empty-text": "Derzeit liegen uns keine Ergebnisse vor. Bitte versuchen Sie es erneut mit neuen Parametern.",
	"feedback-title": "Hilf uns zu verbessern",
	"feedback-intro": "Hinterlassen Sie uns Ihre Kritik und Meinungen, damit wir Pickly für Sie verbessern können.",
	"feedback-improve": "Hat Pickly Ihr Restauranterlebnis verbessert?",
	"feedback-error": "Bitte wähle eine Option aus",
	"feedback-harder": "Kompliziert",
	"feedback-no-help": "Hat nicht geholfen",
	"feedback-indiferent": "Gleichgültig",
	"feedback-helped": "Hat geholfen",
	"feedback-helped-a-lot": "Hat mir sehr geholfen",
	"feedback-recommend": "Würden Sie anderen Restaurants empfehlen, Pickly zu verwenden?",
	"feedback-no-recommend": "Ich empfehle nicht",
	"feedback-recommend-neutral": "Gleichgültig",
	"feedback-recommend-yes": "ich empfehle",
	"feedback-msg": "Hinterlassen Sie uns Ihre Meinung zu Ihrer Erfahrung und wie Sie glauben, dass wir die Anwendung verbessern könnten. (Optional)",
	"feedback-submit": "Einreichen",
	"feedback-thanks-title": "Vielen Dank",
	"feedback-thanks-text": "Vielen Dank, dass Sie uns bei der Verbesserung helfen! Sie können mit der Schaltfläche unten zum Anfang zurückkehren.",
	"restaurant-feedback-title": "Ihre Meinung ist wichtig.",
	"restaurant-feedback-subtitle": "Hilf uns zu verbessern.",
	"restaurant-feedback-intro": "Erzählen Sie uns anhand eines kurzen Fragebogens von Ihren Erfahrungen in unserem Restaurant und bewerten Sie den Service, das Essen und die Umwelt.",
	"restaurant-feedback-intro-btn": "Feedback geben",
	"food-feedback-title": "Lebensmittelbewertung",
	"food-feedback-intro": "Geben Sie Ihre Meinung ab und helfen Sie uns, uns zu verbessern.",
	"choice-question": "Die Speisekarte hatte eine gute Auswahl an Gerichten",
	"presentation-question": "Die Gerichte hatten eine gute Präsentation",
	"tasty-question": "Das Essen war lecker und gut zubereitet",
	"service-feedback-title": "SERVICE-Bewertung",
	"speed-question": "Sie haben unsere Anfrage schnell bearbeitet",
	"waiters-question": "Die Angestellten waren freundlich und aufmerksam",
	"overall-question": "Insgesamt war der Service gut",
	"global-feedback-title": "GLOBALE Bewertung",
	"deco-question": "Das Restaurant hatte eine gute Atmosphäre und Einrichtung",
	"price-question": "Das Preis / Leistungsverhältnis war gut",
	"recommend-question": "Würde das Restaurant einem Freund empfehlen",
	"comments-question": "Kommentare und Vorschläge",
	"recommend_title": "Würden Sie dieses Gericht empfehlen?",
	"recommend-total": "{total} Kunden empfehlen dieses Gericht.",
	"type": "typ",
	"body": "körper",
	"region": "region",
	"accidity": "säure",
	"mypick-text": "Mit myPick wählen Sie Ihre Lieblingsgerichte, Getränke und Desserts für diese Mahlzeit aus. Dann fragen Sie einfach den Kellner.",
	"cookie-notice": "Durch die Nutzung dieser Website stimmen Sie der Verwendung von Cookies für Analysen und Statistiken zu.",
	"terms-title": "Geschäftsbedingungen",
	"price_under_request": "Preis auf anfrage"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/de-de.json
 ** module id = 273
 ** module chunks = 0
 **/